import '@vidstack/react/player/styles/default/theme.css';
import '@vidstack/react/player/styles/default/layouts/audio.css';

import "./AudioPlayer.scss"

import Plyr, {usePlyr} from "plyr-react";
import "plyr-react/plyr.css"
import {useRef} from "react";

export default function AudioPlayer(
    {
        url = "",
        file,
        name = "",
        className = ""
    }) {


    const audioSrc = {
        type: 'audio',
        title: 'Example title',
        sources: [
            {
                src: url,
                type: 'audio/mp3',
            }
        ],
        options: {
            controls:
                [
                    'play',
                    'progress',
                    'duration',
                    'mute',
                    'volume',
                    'download',
                ]
        }
    };

    const options = {
        controls:
            [
                'play',
                'progress',
                'duration',
                'mute',
                'volume',
            ]
    }

    return (
        <div className={`baseAudioPlayer ${className}`}>
            <Plyr options={options} source={audioSrc}/>
        </div>
    )
}